module.exports = __webpack_public_path__ + "ff2e8caecbece05a81490c9d6028e3cc.svg";